<template>
    <v-hover v-slot="{ hover }" >
      <router-link
        class="card"
        :class="{ 'on-hover': hover && (project.disabled == 'false')}"  
        :is="project.disabled == 'true' ? 'span' : 'router-link'" 
        style="text-decoration: none;" 
        :to="{ name: 'ConvPage', params: { powerpointId: project.id, powerpointURL: project.url, alles: project.alles }}">
        <v-img
          :class="project.disabled == 'true' ? 'imgdisabled' : ''"
          height="15vh"
          style="border-radius: 10px; filter: brightness(180%);filter: saturate(50%);filter: contrast(120%);"
          :src="require('@/assets/modern.png')"
          >
          <!-- src="https://cdn.vuetifyjs.com/images/parallax/material.jpg" -->
          <!-- :src="require('@/' + project.img)" -->
          <h2 class="white--text text-center pt-md-10 pt-5" style="text-decoration: none; text-decoration-color:grey; filter: drop-shadow(0px 0px 3px #000000);">{{project.name}}</h2>
          <h5 v-if="!isMobile()" class="white--text text-center pt-0" style="filter: drop-shadow(0px 0px 3px #000000);">{{project.sub}}</h5>
        </v-img>
      </router-link>
    </v-hover>
  </template>
    
  <script>
  import store from '@/store'

    export default {
      name: 'PowerPointButton',
      props: {
      project: Object,
      },
      methods:{
        hskChoose(hskLevel) {
          store.commit("PAGE", hskLevel);
        },
        isMobile() {
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            return true
          } else {
            return false
          }
        },
      }
    }
  </script>
    
    <style scoped>
     .card {
      opacity: 0.9;
      filter: blur(0.3px) drop-shadow(0px 0px 1px #000000);
     }
     .imgdisabled{
      opacity: 0.5;
      box-shadow: 0px 0px 3px #000000;
     }
    .on-hover {
      opacity: 1;
      filter: blur(0px) drop-shadow(0px 0px 5px #000000);
     }
    </style>